export default __webpack_public_path__ + "static/shuffleLabs-9c0bc8438bbdc0a0d72f4a9216bf838c.png";